module.exports = "<p>\r\n  reportlineitem works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/myreports/reportlineitem/reportlineitem.component.html
// module id = ./src/app/myreports/reportlineitem/reportlineitem.component.html
// module chunks = main